/**
 * @generated SignedSource<<5859a438b63cd2ded02f63f073846fc2>>
 * @relayHash b573a817cc8750bab77217970b34b53a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAttachmentFilterInput = {
  authorIds?: ReadonlyArray<string> | null | undefined;
  dateRange?: JiraDateTimeRange | null | undefined;
  fileName?: string | null | undefined;
  mimeTypes?: ReadonlyArray<string> | null | undefined;
};
export type JiraDateTimeRange = {
  after?: AGG$DateTime | null | undefined;
  before?: AGG$DateTime | null | undefined;
};
export type uiJWMAttachmentsQuery$variables = {
  attachmentCount: number;
  cloudId: string;
  durationInSeconds: number;
  filters: JiraAttachmentFilterInput;
  maxTokenLength: number;
  projectKey: ReadonlyArray<string>;
};
export type uiJWMAttachmentsQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"grid_businessAttachments_GridAttachment_jiraQuery">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"grid_businessAttachments_GridAttachment_query">;
};
export type uiJWMAttachmentsQuery = {
  response: uiJWMAttachmentsQuery$data;
  variables: uiJWMAttachmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attachmentCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationInSeconds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxTokenLength"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "durationInSeconds",
  "variableName": "durationInSeconds"
},
v9 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v10 = {
  "kind": "Variable",
  "name": "maxTokenLength",
  "variableName": "maxTokenLength"
},
v11 = [
  (v6/*: any*/),
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "attachmentCount"
  },
  {
    "kind": "Variable",
    "name": "projectKeys",
    "variableName": "projectKey"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiJWMAttachmentsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v7/*: any*/),
              "kind": "FragmentSpread",
              "name": "grid_businessAttachments_GridAttachment_jiraQuery"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "attachmentCount",
            "variableName": "attachmentCount"
          },
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "grid_businessAttachments_GridAttachment_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiJWMAttachmentsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "mediaClientId"
          },
          {
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "mediaExternalEndpointUrl"
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraAttachmentConnection",
            "kind": "LinkedField",
            "name": "attachmentSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraAttachmentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v13/*: any*/),
                          {
                            "alias": "fields",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                  "summary",
                                  "issuetype"
                                ]
                              }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "text"
                                          }
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "name"
                                              },
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                  }
                                                ]
                                              },
                                              (v13/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      (v13/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\"])"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "attachmentId"
                          },
                          {
                            "args": [
                              (v8/*: any*/),
                              (v10/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "parentName"
                          },
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              },
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraAttachment"
                          }
                        ],
                        "type": "JiraPlatformAttachment"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      },
                      (v14/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "args": (v11/*: any*/),
            "filters": [
              "cloudId",
              "projectKeys",
              "filters"
            ],
            "handle": "connection",
            "key": "JiraAttachmentsFragment_attachmentSearch",
            "kind": "LinkedHandle",
            "name": "attachmentSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8",
    "metadata": {},
    "name": "uiJWMAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d4915489ce71b78034e18c891eb7fc7e";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
